import { render, staticRenderFns } from "./AddFAQs.vue?vue&type=template&id=717313d9&scoped=true"
import script from "./AddFAQs.vue?vue&type=script&lang=js"
export * from "./AddFAQs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717313d9",
  null
  
)

export default component.exports